import React, { useState } from 'react';
import {
  ProfFiltersDropdown,
  UsersIcon,
  AllUsersIcon,
  PencilIcon,
  GroupOption,
} from './styles';
import PropTypes from 'prop-types';
import { CreateGroupsModal } from 'apps/journey/pages/professional-center/professional-outcomes/components/create-groups-modal';
import useModalToggle from 'library/hooks/use-modal-toggle';
import KeyCodes from 'library/helpers/key-codes';
import {
  StyledToolTip,
  StyledToolTipLabel,
  ToolTipContainer,
} from 'apps/journey/pages/career-exploration/components/filters/styled-filter-controls';

const CreateGroupsModalTrigger = ({ toggleModal }) => {
  return (
    <React.Fragment>
      <GroupOption
        aria-label="Select to edit or create groups"
        onClick={toggleModal}
        onKeyPress={(e) => {
          if (KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which)) {
            toggleModal();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <PencilIcon /> Edit or Create Groups
      </GroupOption>
    </React.Fragment>
  );
};

const ProfessionalCenterGroupsList = ({
  handleValueChange,
  groupFilters,
  groupOptions,
  reload_filters,
  organizationId,
}) => {
  const [selectedGroup, setSelectedGroup] = useState();
  const [dropdownActive, setDropdownActive] = useState(false);
  const { active, toggleModal } = useModalToggle();
  const groupKey = 'professional_center_group_membership_ids';

  const toggleModalAndReload = () => {
    reload_filters(); // don't await this before closing the modal - we don't care about the result
    toggleModal();
  };

  const handleResetGroups = () => {
    handleValueChange({
      target: {
        name: groupKey,
        value: [],
      },
    });
    setSelectedGroup(null);
  };

  const handleGroupKeyPress = (e) => {
    if (KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which)) {
      handleGroupChange(e);
    }
  };

  const handleGroupChange = (e) => {
    const filterId = Number(e?.target?.getAttribute('value'));
    // if it's active, we want to toggle it off
    const isCurrentlyActive = groupFilters?.professional_center_group_membership_ids?.includes(
      filterId
    );
    handleValueChange({
      target: {
        name: e?.target?.getAttribute('name'),
        value: isCurrentlyActive
          ? []
          : [Number(e?.target?.getAttribute('value'))],
      },
    });
    setSelectedGroup(
      e?.target?.getAttribute('label') == selectedGroup
        ? null
        : e?.target?.getAttribute('label')
    );
  };

  const renderOptions = () => {
    const options = groupOptions.map((filter, i) => (
      <GroupOption
        key={filter.id || i}
        role="button"
        tabIndex={0}
        name={groupKey}
        label={filter.name}
        aria-label={filter.name}
        active={groupFilters?.professional_center_group_membership_ids?.includes(
          filter.id
        )}
        value={filter.id}
        onClick={handleGroupChange}
        onKeyPress={handleGroupKeyPress}
      >
        {filter.name}
      </GroupOption>
    ));
    options.push(
      <CreateGroupsModalTrigger active={active} toggleModal={toggleModal} />
    );
    options.unshift(
      <GroupOption
        role="button"
        aria-label="Unset the current group filter"
        onClick={handleResetGroups}
        onKeyPress={(e) => {
          if (KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which)) {
            handleResetGroups();
          }
        }}
        tabIndex={0}
      >
        <AllUsersIcon /> All Individuals
      </GroupOption>
    );
    return options;
  };

  const toggleDropdown = () => {
    setDropdownActive(!dropdownActive);
  };

  return (
    <React.Fragment>
      <CreateGroupsModal active={active} toggleActive={toggleModalAndReload} />
      {dropdownActive ? (
        <ProfFiltersDropdown
          label="Groups"
          name="prof_center_group_filters"
          placeholder={selectedGroup || 'None Selected'}
          contentClassName="prof_center_group_filters"
          icon={UsersIcon}
          iconProps={{ onClick: toggleDropdown }}
        >
          {renderOptions()}
        </ProfFiltersDropdown>
      ) : (
        <ToolTipContainer>
          <StyledToolTip aria-label="Filter by groups" tabIndex={0}>
            <UsersIcon onClick={toggleDropdown} />
            <StyledToolTipLabel>Groups</StyledToolTipLabel>
          </StyledToolTip>
        </ToolTipContainer>
      )}
    </React.Fragment>
  );
};

ProfessionalCenterGroupsList.defaultProps = {
  handleValueChange: (e) => null,
  groupFilters: {},
  groupOptions: [],
  reload_filters: () => null,
};
ProfessionalCenterGroupsList.propTypes = {
  handleValueChange: PropTypes.func,
  groupFilters: PropTypes.object,
  groupOptions: PropTypes.array,
  reload_filters: PropTypes.func,
};

export default ProfessionalCenterGroupsList;
